export const environmentProd = {
  priismApptApiEndPoint: "/api/v1",
  priismApiEndPoint: "https://priism.in/priismapp/v1",
  // Priism v2 API origin (no /v1 suffix — paths already include /v1/public/...).
  // Direct: "https://priism.in". Or use a same-origin reverse-proxy ("/api")
  // to avoid CORS (this domain's /api → priism.in).
  priismV2ApiEndPoint: "https://priism.in",
  // Razorpay public Key IDs — safe to commit; they ship in the browser bundle by design.
  // Secrets (Key Secret, webhook secret) must live on the backend, never here.
  razorpayKeyId: "rzp_live_5dsWJO6EQJhjw2",
  razorpayKeyIdManoshanti: "rzp_live_SfczOOFjO2Ni9j",
  razorpayKeyIdSthira: "rzp_live_Sfdoeth2p4KIVy"
};
